export { default } from './RenderGeoname';
